module.exports = __webpack_public_path__ + "static/media/how_to_get_pococha_account_url.1d365549.png";